import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Document, Text } from '@reveni-io/reveni-ui'

import { getReturnLabelsFormatted } from './helpers'

const ReturnLabels = ({ returnLabels }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (!returnLabels || returnLabels.length === 0) {
    return null
  }

  return (
    <>
      <Text
        type="allCapsM"
        customStyles={{
          textTransform: 'uppercase',
        }}
        color={theme.colors.grey.tone500}
      >
        {t('Etiquetas de envío')}
      </Text>
      {getReturnLabelsFormatted(returnLabels).map((label, index) => (
        <Document key={`${index}-label`} document={label} />
      ))}
    </>
  )
}

export default ReturnLabels
